import { Radio } from '@arco-design/web-react';
import { useTranslation } from 'react-i18next';
import { useFilters } from '@/context/FilterContext';
import type { MoneyView } from '@/types/Transaction';

const VIEWS: MoneyView[] = ['gross', 'net', 'refund'];

export function MoneyViewToggle() {
  const { filters, dispatch } = useFilters();
  const { t } = useTranslation();

  return (
    <div className="aiobi-filter">
      <label className="aiobi-filter__label">{t('filters.moneyView.label')}</label>
      <Radio.Group
        type="button"
        value={filters.moneyView}
        onChange={(v) => dispatch({ type: 'SET_MONEY_VIEW', payload: v as MoneyView })}
        size="small"
      >
        {VIEWS.map((v) => (
          <Radio key={v} value={v}>
            {t(`filters.moneyView.${v}`)}
          </Radio>
        ))}
      </Radio.Group>
    </div>
  );
}
